'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import Container from '@/components/ui/Container'
import Icon from '@/components/ui/icon'
import Popover from '@/components/ui/Popover'
import { useConfigContext } from '@/context/ConfigProvider'
import { cn } from '@/lib/utils'
import { eGeneralInfo } from '@/types/enum'

export default function FooterInfo() {
  const [expanded, setExpanded] = useState(false)
  const [content, setContent] = useState('')
  const [openHour, setOpenHour] = useState(false)
  const pathname = usePathname()

  const t = useTranslations('footer')
  const { locale, getBasic } = useConfigContext()
  const info = getBasic(eGeneralInfo.company_info)

  const details = [
    { title: t('map'), icon: 'tgic icon-map-marker', path: '/lien-he', color: '#c01313' },
    { title: t('microchip'), icon: 'tgic icon-microchip-solid', path: '/san-pham', color: '' },
    { title: t('pcb'), icon: 'tgic icon-th-large-solid', path: '/pcb', color: '#174fb7' },
    { title: t('news'), icon: 'tgic icon-newspaper', path: '/tin-tuc', color: '#ff9800' },
    { title: t('warranty'), icon: 'tgic icon-wrench', path: '/cong-ty/quy-dinh-bao-hanh', color: '#c01313' },
  ]

  useEffect(() => {
    if (typeof info === 'string' && locale) {
      setContent(info)
    }
  }, [info, locale])

  const getPreviewText = () => {
    const paragraphs = content.split(/<\/p>/i)
    if (paragraphs.length > 2) {
      return (
        paragraphs.slice(0, 2).join('</p>') +
        `<span class='info-view-more-dot'>..</span><span class='info-view-more ml-1' id='view-more'>Xem thêm <i class='tgic icon-chevron-down'></i></span>`
      )
    }
    return content
  }

  const getFullTextWithCollapse = () => {
    const paragraphs = content.split(/<\/p>/i)
    if (paragraphs.length > 2) {
      return paragraphs.slice(0, paragraphs.length - 1).join('</p>') + `<span class='info-view-less' id='view-less'>Thu gọn <i class='tgic icon-chevron-up'></i></span></p>`
    }
    return content
  }

  useEffect(() => {
    const viewMoreButton = document.getElementById('view-more')
    const viewLessButton = document.getElementById('view-less')

    if (viewMoreButton) {
      viewMoreButton.addEventListener('click', () => setExpanded(true))
    }

    if (viewLessButton) {
      viewLessButton.addEventListener('click', () => setExpanded(false))
    }

    return () => {
      if (viewMoreButton) {
        viewMoreButton.removeEventListener('click', () => setExpanded(true))
      }

      if (viewLessButton) {
        viewLessButton.removeEventListener('click', () => setExpanded(false))
      }
    }
  }, [content, expanded])

  return (
    <div
      className={cn('bg-[#f8fafc]', {
        'pt-4': pathname === '/' && content,
      })}
    >
      <Container>
        <div className="text-sm">
          {pathname === '/' && <div id="company_info" dangerouslySetInnerHTML={{ __html: expanded ? getFullTextWithCollapse() : getPreviewText() }} />}
          <div className="flex items-center justify-between py-4">
            <div className="text-xl text-green-700" dangerouslySetInnerHTML={{ __html: `${getBasic(eGeneralInfo.phone)}` }}></div>
            <div className="relative flex items-center justify-start" onClick={() => setOpenHour(!openHour)}>
              <div className="inline-flex items-center gap-1 cursor-pointer hover:opacity-50">
                <Icon icon="tgic icon-clock" className="text-green-700" />
                <span>{t('open_hour')}</span>
                <Icon icon="tgic icon-chevron-down" />
              </div>
              <Popover isOpen={openHour} onClose={() => setOpenHour(false)} className="w-max p-1.5">
                <div dangerouslySetInnerHTML={{ __html: `${getBasic(eGeneralInfo.work_time)}` }} />
              </Popover>
            </div>
            {details?.map((route) => (
              <div key={route.icon} className="flex items-center justify-start lg:justify-center text-sm">
                <Link
                  href={route.path}
                  className="flex items-center gap-1 lg:p-1 lg:px-2 lg:border border-opacity-0 border-primary lg:hover:border-opacity-100 lg:hover:text-primary duration-50 rounded-full"
                >
                  <Icon icon={route.icon} style={{ color: route.color }} />
                  <span>{route.title}</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}
